// 蒙版TAG
const MASK_TAG = "Authorize";
/**
 * 授权管理类，用来处理授权问题
 */
class AuthorizeManager {
    constructor() {
        this.m_StartStageLvl = 31;
        this.m_StageInterval = 10;
    }
    static getInstance() {
        if (AuthorizeManager.s_Instance == null) {
            AuthorizeManager.s_Instance = new AuthorizeManager();
        }
        return AuthorizeManager.s_Instance;
    }
    initCfg() {
        CfgManager.load("game").then((data) => {
            let gameConfig = CfgManager.get("game");
            this.m_StartStageLvl = Number(gameConfig["register_test_stage_level"]) || 31;
            this.m_StageInterval = Number(gameConfig["register_test_stage_num"]) || 10;

            this.is_check_anthorize = gameConfig["is_check_anthorize"] ? Number(gameConfig["is_check_anthorize"]) : 1
            this.is_check_anthorize_start_level = gameConfig["is_check_anthorize_start_level"] ? Number(gameConfig["is_check_anthorize_start_level"]) : 0
            cc.log("AuthorizeManager initCfg is_check_anthorize ",this.is_check_anthorize)
            cc.log("AuthorizeManager initCfg is_check_anthorize_start_level ",this.is_check_anthorize_start_level)
            // this.is_check_anthorize = 0

            CfgManager.release("game");
        }).catch(() => {
            console.log("[!!!!]load cfg fail");
            CfgManager.release("game");
            this.m_StartStageLvl = 31;
            this.m_StageInterval = 10;

            this.is_check_anthorize = 1
            this.is_check_anthorize_start_level = 0
        });
    }
    /**获取确认授权开始关卡 */
    get StartStageLvl() {
        return this.m_StartStageLvl;
    }
    /**获取关卡间隔 */
    get StageInterval() {
        return this.m_StageInterval;
    }
    /**
     * 授权验证
     * @param agreeCb 授权通过回调 false: 用户没有授权状态的变更； true：用户从未授权->授权
     * @param denyCb 授权不通过回调
     * @param msg 需要显示的文本
     * @param dcType 打点类型
     * @param needMask 是否需要蒙版禁用一切点击
     * @param quiet 静默检查 为true时用户如果没有授权，不弹窗请求用户授权，直接调用denyCb
     * @param anonymousPop 匿名用户是否需要展示弹窗，默认false
     */
    checkAuthorize(agreeCb, denyCb, msg, dcType, needMask = true, quiet = false, anonymousPop = false) {
        //wanba oppo频台不支持授权
        if (typeof (mini) == 'undefined' || !mini.supportAuthorize()) {
            if (agreeCb) {
                agreeCb(false);
            }
            return;
        }
        let needAuthorize = false;
        let firstAuthorize = false;
        if (needMask) {
            showGlobalMask(MASK_TAG);
        }
        function callback(agree) {
            hideGlobalMask(MASK_TAG);
            if (!agree) {
                if (denyCb) {
                    denyCb(false);
                }
            }
            else {
                if (agreeCb) {
                    //授权成功打点
                    DCAssist.userTrack("user_click", "wechat_info_ask_success", { type: dcType });
                    agreeCb(true);
                }
            }
        }
        function onNeedAuthorize(res) {
            const OPEN_AUTHORIZE_NUM = "open_authorize_num"
            let num = Localhost.getInstance().getDailyDataByKey(OPEN_AUTHORIZE_NUM, 0)
            if (quiet || num > 0) {
                console.log("[####]onNeedAuthorize num:" ,num);
                hideGlobalMask(MASK_TAG);
                denyCb && denyCb(false);
                if ( num > 0){
                    window.logCenter && logCenter.error(new Error(`Authorize open `), 'AuthorizeError')
                }
            }
            else {
                if (typeof res.authSetting === "undefined" || typeof (res.authSetting["scope.userInfo"]) == 'undefined') {
                    firstAuthorize = true;
                }
                num++ 
                Localhost.getInstance().setDailyDataByKey(OPEN_AUTHORIZE_NUM, num)
                //弹出授权界面打点
                DCAssist.userTrack("user_click", "wechat_info_ask_show", { type: dcType });
                //TODO:panel use ts
                // let authorizePanel = require('./clover/utils/AuthorizePanel')
                // let panel = authorizePanel.create()
                hideGlobalMask(MASK_TAG);
                let Authorize = require('./clover/utils/AuthorizePanel');
                Authorize.showPanel(msg, callback, callback, dcType, firstAuthorize);
            }
        }
        if (!mini.isPlatformLogin()) {
            if (anonymousPop) {
                onNeedAuthorize({});
            }
            else {
                hideGlobalMask(MASK_TAG);
                denyCb && denyCb(false);
            }
        }
        else if (mini.supportGetUserInfo()) {
            let cnt = 0
            let cntCb = (isSuccess,res)=>{
                console.log("[####]cntCb cnt:" ,cnt);
                if (cnt > 0){
                    console.log("supportGetUserInfo cnt:" ,cnt);
                    return
                }
                cnt++ 
                if (isSuccess){
                    console.log("[####]getSetting success authsetting:" + JSON.stringify(res));
                    if (!res.authSetting || !res.authSetting["scope.userInfo"]) {
                        needAuthorize = true;
                    }
                    if (needAuthorize) {
                        onNeedAuthorize(res);
                    }
                    else {
                        hideGlobalMask(MASK_TAG);
                        if (agreeCb) {
                            agreeCb(false);
                        }
                    }
                }else{
                    console.log("[!!!!]getsetting failed");
                    hideGlobalMask(MASK_TAG);
                    if (denyCb) {
                        denyCb(false);
                    }
                }
            }
            mini.getSetting({
                success: function (res) {
                    cntCb(true,res)
                },
                fail: function () {
                    cntCb(false)
                }
            });
            setTimeout(()=>{
                if (cnt <= 0){
                    window.logCenter && logCenter.error(new Error(`mini.getSetting time out`), 'AuthorizeError')
                }
                cntCb(false)
            },1000)
        }
        else {
            onNeedAuthorize({});
        }
    }

    // 展示授权提示界面
    showAuthorizeTipPanel(cb){
        let onResLoad = () => {
            let panel = AuthorizeGuideTipPanel.create({
                showType:1,
                cb:cb
            })
            panel.popup(true)
        }
        let onFail = () => {
        }
        // var AuthorizeTipPanel = require("clover/panel/component/authorize/AuthorizeTipPanel")
        // AuthorizeTipPanel.preloadRes(onResLoad, onFail);
        var AuthorizeGuideTipPanel  = require("clover/panel/component/authorize/AuthorizeGuideTipPanel")
        AuthorizeGuideTipPanel.preloadRes(onResLoad, onFail);
    }
    // 展示授权引导提示界面
    showAuthorizeGuidePanel(cb,cancelCb){
        let onResLoad = () => {
            let panel = AuthorizeGuideTipPanel.create({
                showType:2,
                cb:cb,
                cancelCb: cancelCb
            })
            panel.popup(true)
        }
        let onFail = () => {
        }
        var AuthorizeGuideTipPanel  = require("clover/panel/component/authorize/AuthorizeGuideTipPanel")
        AuthorizeGuideTipPanel.preloadRes(onResLoad, onFail);
    }
    // 是否授权 key取自MiniScope
    isAuthorizeByScope(scopeKey){
        cc.log("AuthorizeManager isAuthorizeByScope ",!this[scopeKey])
        return !this[scopeKey]
    }
    
    
    setAutoOpenSetting(scopeKey){
        let key = "auto_open_setting_" + scopeKey
        cc.UserDefault.getInstance().setBoolForKey(key, false)
    }
    getAutoOpenSetting(scopeKey){
        let key = "auto_open_setting_" + scopeKey
        return cc.UserDefault.getInstance().getBoolForKey(key, true);
    }

    // 检查授权
    checkAuthorizeByScope(scopeKey,agreeCb, denyCb,isShowTip,isGuide){
        cc.log("AuthorizeManager checkAuthorizeByScope scopeKey ",scopeKey)
        let self = this;
        // wanba oppo频台不支持授权
        if (typeof (mini) == 'undefined' || !mini.supportAuthorize()) {
            if (agreeCb) {
                agreeCb();
            }
            return;
        }
        // 如果该渠道没有此权限，则走已经授权逻辑
        let scope = MiniScope ? MiniScope[scopeKey] : null;
        if (!scope){
            if (agreeCb) {
                agreeCb();
            }
            return
        }
        if ( this.is_check_anthorize != 1){
            if (agreeCb) {
                agreeCb();
            }
            return
        }
        DCAssist.dc4User101("api", "getSetting", {"type": "start"})
        mini.getSetting({
            withSubscriptions: false,
            success(res){
                console.log("getSetting", res)
                DCAssist.dc4User101("api", "getSetting", {"mode": "success"})
                if (res.authSetting == null || res.authSetting[scope] == null){
                    // 没有授权
                    self[scopeKey] = true;
                    // isShowTip == true 提示授权 并进行授权 反之直接反馈信息
                    if (isShowTip){
                        self.showAuthorizeTipPanel(()=>{
                            self.doAuthorize(scopeKey,agreeCb,denyCb)
                        });
                    }else{
                        // if (denyCb) {
                        //     denyCb();
                        // }
                        self.doAuthorize(scopeKey,agreeCb,denyCb)
                    }
                }else if(res.authSetting[scope] == true) {
                    // 已经授权
                    // 无视
                    self[scopeKey] = false;
                    if (agreeCb) agreeCb();
                }else{
                    // 拒绝授权
                    self[scopeKey] = true
                    // 返回拒绝授权 功能进行特殊处理和提示
                    if(isGuide && self.getAutoOpenSetting(scopeKey)){
                        self.setAutoOpenSetting(scopeKey)
                        self.showAuthorizeGuidePanel(()=>{
                            cc.log("AuthorizeManager checkAuthorizeByScope isGuide cb ")
                            self.openSetting(scopeKey,agreeCb,denyCb)
                        },()=>{
                            cc.log("AuthorizeManager checkAuthorizeByScope isGuide canbelCb ")
                            if (denyCb) {
                                denyCb();
                            }
                        });
                    }else{
                        if (denyCb) {
                            denyCb();
                        }
                    }
                }
            },
            fail(){
                DCAssist.dc4User101("api", "getSetting", {"mode": "fail"})
                self[scopeKey] = true
                if (agreeCb) {
                    agreeCb();
                }
            }
        })


    }

    // 进行授权
    doAuthorize(scopeKey,agreeCb, denyCb){
        let self = this;
        let scope = MiniScope[scopeKey]
        DCAssist.dc4User101("api", "authorize", {"type": "start"})
        mini.authorize({
            scope: scope,
            content:"",
            success(){
                cc.log("AuthorizeManager doAuthorize success ")
                DCAssist.dc4User101("api", "authorize", {"mode": "success"})
                self[scopeKey] = false;
                if (agreeCb) agreeCb();
            },
            fail(res){
            //   "授权失败"+res.errMsg
                cc.log("AuthorizeManager doAuthorize fail ")
                DCAssist.dc4User101("api", "authorize", {"mode": "fail"})
                self[scopeKey] = true;
                if (denyCb) denyCb();
            }
        })
    }

    // 引导打开设置面板授权
    openSetting(scopeKey,agreeCb, denyCb){
        cc.log("checkAuthorizeByScope openSetting scopeKey ",scopeKey)
        let self = this;
        let scope = MiniScope[scopeKey]
        DCAssist.dc4User101("api", "openSetting", {"type": "start"})

        mini.openSetting({
            withSubscriptions: false,
            success(res){
                DCAssist.dc4User101("api", "openSetting", {"mode": "success"})
                if (res.authSetting && res.authSetting[scope] == true){
                    self[scopeKey] = false
                    if (agreeCb) agreeCb();
                }else{
                    self[scopeKey] = true
                    if (denyCb) denyCb();
                }
            },
            fail(res){
                DCAssist.dc4User101("api", "openSetting", {"mode": "fail"})
                self[scopeKey] = true
                if (denyCb) denyCb();
            }
        })
 7
    }



    // 检查授权 进行授权 反馈状态 在对应功能上进行展示 

}
module.exports = AuthorizeManager;
